module.exports = __webpack_public_path__ + "static/media/mp4.8c10af8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4.mp4
// module id = 2O+c
// module chunks = 1